import { ClusterCluster } from '@clinic/client'

import { axiosInstance } from './base'

const grafanaBasePath = '/grafana/api/datasources/proxy/1/api/v1'

export interface GrafanaQueryRangeParams {
  query: string
  orgId: string
  clusterId: string
  start: number
  end: number
  step: string
  isCloud: boolean
}

export function grafanaQueryRange({
  query,
  orgId,
  clusterId,
  start,
  end,
  step,
  isCloud
}: GrafanaQueryRangeParams) {
  return axiosInstance.get(
    `/query_range?query=${query}&var-org=${orgId}&var-tidb_cluster=${clusterId}&start=${start}&end=${end}&step=${step}${
      isCloud ? '&var-org_type=cloud' : ''
    }`,
    {
      baseURL: grafanaBasePath
    }
  )
}

// TODO: refine
export function getNodeInstance({
  pod,
  cluster
}: {
  pod: string
  cluster: ClusterCluster
}) {
  const controlPlaneInfo = `seed/${cluster.provider}-${cluster.region}`
  return axiosInstance
    .get(
      // `/clinic/api/v1/data/control_plane/metrics?query=kube_pod_info{namespace=~".*1373933076658121164",pod=~"db-pd-1",control_plane_info="seed/aws-us-west-2"}`
      `/clinic/api/v1/data/control_plane/metrics?query=kube_pod_info{namespace=~".*${cluster.id}",pod=~"${pod}",control_plane_info="${controlPlaneInfo}"}`
    )
    .then((res) => res.data)
    .then((d) => d.data.result[0]?.metric.node)
}

// TODO: use swagger generated method
export function grafanaQueryRangeForControlPlane({
  cluster,
  query,
  start,
  end,
  step
}: {
  cluster: ClusterCluster
  query: string
  start: number
  end: number
  step: number
}) {
  const controlPlaneInfo = `seed/${cluster.provider}-${cluster.region}`
  return axiosInstance.get(
    `/clinic/api/v1/data/control_plane/metrics?query=${query}&start=${start}&end=${end}&step=${step}`,
    {
      headers: {
        control_plane_info: controlPlaneInfo
      }
    }
  )
}
